import React, { useRef, useEffect } from 'react';
import CountdownOverlay from '../components/CountdownOverlay';
import { useStream } from '../contexts/StreamContext';
import ViewerCount from '../components/ViewerCount';
import styles from './StreamPageUI.module.css';
import StartBroadcastButton from "../components/StartBroadcastButton"
import RecordButton from '../components/RecordButton';

const StreamPageUI = ({videoRef}) => {
  const videoContainerRef = useRef(null);

  const {
    streaming,
    previewing,
    showCountdown,
    startPreview,
    stopStreaming,
    handleStart,
    handleCountdownComplete,
    registerVideoRef
  } = useStream(videoRef);

  useEffect(() => {
    if (videoRef.current) {
      registerVideoRef(videoRef);
    }
  }, [videoRef, registerVideoRef]);

  return (
    <div>
      <div className={styles.startBroadcast}>
        
        <img src="/start-broadcast.jpg"></img>
        <p>Lets get started</p>
        <span>Tap the button to begin preview</span>
        <StartBroadcastButton onClick={() => startPreview(videoRef)}></StartBroadcastButton>
      </div>
      <div className={`${styles.fullscreenStream} ${streaming || previewing ? '' : styles.hidden}`} ref={videoContainerRef}>
        {showCountdown && <CountdownOverlay onComplete={handleCountdownComplete} />}
        <img src="/logo-small.png" alt="Castly Logo" className={styles.streamLogo}/>
        <video ref={videoRef} autoPlay playsInline className={styles.streamVideoPos}></video>
        <button onClick={stopStreaming} className={styles.closePreviewBtn} hidden={!previewing}>✖</button>
        
        {streaming && 
          <>
            <div className={styles.liveIcon}>LIVE</div>
            <ViewerCount />
          </>
        }
        
        <div className={styles.recordButtonPos}>
          <RecordButton   
            onStart={handleStart}
            onStop={stopStreaming}
            isPreviewing={previewing}
          />
        </div>
      </div>
    </div>
  );
};

export default StreamPageUI;